import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoPrivilegesModule } from 'mojo-privileges';

import { DaysPassedPipeModule } from '@shared/pipes/days-passed/days-passed.module';

import { UserItemComponent } from './user-item.component';
import { UsersConfig } from './users.abstract.config';
import { usersConfig } from './users.config';

@NgModule({
  imports: [
    CommonModule,
    MojoAvatarModule,
    DaysPassedPipeModule,
    MatIconModule,
    MojoPrivilegesModule,
  ],
  exports: [UserItemComponent],
  declarations: [UserItemComponent],
  providers: [
    {
      provide: UsersConfig,
      useValue: usersConfig,
    },
  ],
})
export class UserItemModule { }
